var __jsx = React.createElement;
import React, { Fragment, useMemo } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { Wrapper } from './styles';
import YourSpace from './YourSpace';
import AboutThisPlace from './AboutThisPlace';
import { RENT_TYPE } from '@spa/shared/constants/rentType';
import { getPropertyRentBy } from '@spa/shared/utils/property';
import SharedSpacesAndAmenities from './SharedSpacesAndAmenities';
import { translateFromLanguage } from '@spa/shared/utils/transformers';
import Separator from '@spa/shared/components/Unisystem/Separator';
var Overview = function Overview(_ref) {
  var isRentByProperty = _ref.isRentByProperty,
    propertyMetadata = _ref.propertyMetadata;
  var _useTranslation = useTranslation(),
    language = _useTranslation.i18n.language;
  var propertyDescription = useMemo(function () {
    return translateFromLanguage(propertyMetadata, language);
  }, [propertyMetadata, language]);
  return __jsx(Wrapper, {
    id: "Overview"
  }, __jsx(YourSpace, {
    isRentByProperty: isRentByProperty
  }), __jsx(Separator, null), !isRentByProperty ? __jsx(Fragment, null, __jsx(AboutThisPlace, {
    propertyDescription: propertyDescription,
    isRentByProperty: isRentByProperty
  }), __jsx(Separator, null)) : null, __jsx(SharedSpacesAndAmenities, null));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$offer$offerAggr = _ref2.offer.offerAggregate,
    _ref2$offer$offerAggr2 = _ref2$offer$offerAggr.accommodation_offer;
  _ref2$offer$offerAggr2 = _ref2$offer$offerAggr2 === void 0 ? {} : _ref2$offer$offerAggr2;
  var unitType = _ref2$offer$offerAggr2.property.unit_type,
    _ref2$offer$offerAggr3 = _ref2$offer$offerAggr.property_aggregate;
  _ref2$offer$offerAggr3 = _ref2$offer$offerAggr3 === void 0 ? {} : _ref2$offer$offerAggr3;
  var _ref2$offer$offerAggr4 = _ref2$offer$offerAggr3.property;
  _ref2$offer$offerAggr4 = _ref2$offer$offerAggr4 === void 0 ? {} : _ref2$offer$offerAggr4;
  var lifecycle = _ref2$offer$offerAggr4.lifecycle,
    typology = _ref2$offer$offerAggr4.typology,
    propertyMetadata = _ref2$offer$offerAggr4.metadata,
    floors = _ref2$offer$offerAggr4.floors,
    photos = _ref2$offer$offerAggr.photos;
  return {
    isRentByProperty: getPropertyRentBy({
      unitType: unitType,
      lifecycle: lifecycle,
      typology: typology
    }) === RENT_TYPE.ENTIRE_PROPERTY,
    propertyMetadata: propertyMetadata
  };
};
export default connect(mapStateToProps)(Overview);